import React from 'react';

const AdminAnalytics: React.FC = () => {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-gray-900">Analytics & Reports</h2>
        <p className="text-sm text-gray-600">View platform performance metrics</p>
      </div>

      <div className="bg-white rounded-xl shadow-sm p-12 text-center border border-gray-100">
        <span className="text-6xl mb-4 block">📈</span>
        <h3 className="text-xl font-bold text-gray-900 mb-2">Analytics Coming Soon</h3>
        <p className="text-gray-600">
          Advanced analytics dashboard with charts and reports will be available here.
        </p>
      </div>
    </div>
  );
};

export default AdminAnalytics;

